module.exports = __webpack_public_path__ + "static/media/08.3c53bb9c.jpg";